<template>
  <span
    class="indicatorItemsSelect"
    :title="valueName && valueName.length > 2 ? valueName : ''"
  >
    <el-select
      v-model="value"
      placeholder="请选择"
      popper-class="theme_inFilter_selectOpt"
      @change="changeVal"
    >
      <el-option
        v-for="item in selectList"
        :key="item.value"
        :label="item.name"
        :value="item.value"
      ></el-option>
    </el-select>
  </span>
</template>

<script>
// 切换指标项 select 组件
export default {
  name: 'IndicatorItemsSelect',
  props: {
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
    selectList: {
      type: Array,
      default: () => {
        return []
      },
    },
    selectId: {
      type: String,
      default: '',
    },
    indexNo: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    selectId: {
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.value = newValue
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      value: '',
    }
  },
  computed: {
    valueName() {
      let valueName = ''
      this.selectList.forEach((item) => {
        if (item.value === this.value) {
          valueName = item.name
        }
      })
      return valueName
    },
  },
  methods: {
    changeVal(val) {
      this.$emit('changeValEvent', {
        indexNo: this.indexNo,
        data: val,
      })
    },
    _valFormatHandler(val, ceil) {
      let data
      // console.debug('_valFormatHandler:', val, typeof val, ceil)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (val && ceil) {
          data = `${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug('_valFormatHandler:', val, data)
      return data
    },
  },
}
</script>
<style lang="scss">
.indicatorItemsSelect {
  position: relative;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  .el-select {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    .el-input {
      font-size: 0;
      &:hover {
        .el-input__inner,
        .el-select__caret {
          color: var(--mixtmt_selectInputActColor);
        }
      }
      &.is-focus {
        .el-input__inner {
          color: var(--mixtmt_selectInputActColor);
        }
        .el-select__caret {
          color: var(--mixtmt_selectInputActColor);
        }
      }
      .el-input__inner {
        padding: 0 calc(2vw * var(--mixtmt_mixvw)) 0
          calc(1vw * var(--mixtmt_mixvw));
        height: calc(2.788vw * var(--mixtmt_mixvw));
        line-height: calc(2.788vw * var(--mixtmt_mixvw));
        font-size: calc(0.972vw * var(--mixtmt_mixvw));
        border: 0;
        background-color: transparent;
        color: var(--mixtmt_whiteColor);
      }
      .el-input__suffix {
        width: calc(2vw * var(--mixtmt_mixvw));
        right: calc(0vw * var(--mixtmt_mixvw));
        overflow: hidden;
      }
      .el-select__caret {
        font-size: calc(0.972vw * var(--mixtmt_mixvw));
        line-height: calc(1.944vw * var(--mixtmt_mixvw));
      }
      .el-input__icon {
        width: calc(2vw * var(--mixtmt_mixvw));
      }
    }
  }
}
.theme_inFilter_selectOpt {
  margin: calc(0.66667vw * var(--mixtmt_indicatorItemSelect_mixvw)) 0;
  border-radius: calc(0.53333vw * var(--mixtmt_indicatorItemSelect_mixvw));
  box-shadow: 0 calc(0.26667vw * var(--mixtmt_indicatorItemSelect_mixvw))
    calc(1.6vw * var(--mixtmt_indicatorItemSelect_mixvw)) 0 rgba(0, 0, 0, 0.1);
  &.el-popper[x-placement^='bottom'] {
    margin-top: calc(
      1.1vw * var(--mixtmt_indicatorItemSelect_mixvw)
    ) !important;
  }
  .el-select-dropdown__wrap {
    max-height: calc(9.5vw * var(--mixtmt_indicatorItemSelect_mixvw));
    .el-select-dropdown__list {
      padding: calc(0.8vw * var(--mixtmt_indicatorItemSelect_mixvw)) 0;
      .el-select-dropdown__item {
        font-size: calc(0.972vw * var(--mixtmt_indicatorItemSelect_mixvw));
        padding: 0 calc(2.2vw * var(--mixtmt_indicatorItemSelect_mixvw));
        color: #606266;
        height: calc(2.5vw * var(--mixtmt_indicatorItemSelect_mixvw));
        line-height: calc(2.5vw * var(--mixtmt_indicatorItemSelect_mixvw));
        &.selected,
        &.hover,
        &:hover {
          color: var(--mixtmt_subColor1_1);
          background-color: var(--mixtmt_subColor1_2);
        }
      }
    }
  }
  .el-scrollbar__bar {
    position: absolute;
    right: calc(0.26667vw * var(--mixtmt_indicatorItemSelect_mixvw));
    bottom: calc(0.26667vw * var(--mixtmt_indicatorItemSelect_mixvw));
    z-index: 1;
    border-radius: calc(0.53333vw * var(--mixtmt_indicatorItemSelect_mixvw));
    &.is-horizontal {
      height: calc(0.8vw * var(--mixtmt_indicatorItemSelect_mixvw));
      left: calc(0.26667vw * var(--mixtmt_indicatorItemSelect_mixvw));
    }
    &.is-vertical {
      width: calc(0.8vw * var(--mixtmt_indicatorItemSelect_mixvw));
      top: calc(0.26667vw * var(--mixtmt_indicatorItemSelect_mixvw));
    }
  }
  &.el-popper[x-placement^='bottom'] .popper__arrow {
    top: calc(-0.8vw * var(--mixtmt_indicatorItemSelect_mixvw));
    margin-right: calc(0.4vw * var(--mixtmt_indicatorItemSelect_mixvw));
    border-top-width: 0;
    &::after {
      top: 1px;
      margin-left: calc(-0.8vw * var(--mixtmt_indicatorItemSelect_mixvw));
      border-top-width: 0;
    }
  }
  &.el-popper .popper__arrow {
    border-width: calc(0.8vw * var(--mixtmt_indicatorItemSelect_mixvw));
    -webkit-filter: drop-shadow(
      0 calc(0.26667vw * var(--mixtmt_indicatorItemSelect_mixvw))
        calc(1.6vw * var(--mixtmt_indicatorItemSelect_mixvw))
        rgba(0, 0, 0, 0.03)
    );
    filter: drop-shadow(
      0 calc(0.26667vw * var(--mixtmt_indicatorItemSelect_mixvw))
        calc(1.6vw * var(--mixtmt_indicatorItemSelect_mixvw))
        rgba(0, 0, 0, 0.03)
    );
    &::after {
      border-width: calc(0.8vw * var(--mixtmt_indicatorItemSelect_mixvw));
    }
  }
}
.itemsLenMin3 {
  .indicatorItemsSelect {
    .el-select {
      .el-input {
        .el-input__inner {
          height: calc(2.083vw * var(--mixtmt_mixvw));
          line-height: calc(2.083vw * var(--mixtmt_mixvw));
        }
      }
    }
  }
}
</style>
